import styled from 'styled-components';
import theme from '../../../../../../styles/theme';

const defaultComponent = styled.div`
  width: 75%;
  height: 0.0625rem;
  margin: 0.5rem 0;
  background-color: ${theme.colors.white};
`;

const Divisor = {
  Default: defaultComponent,
};

export default Divisor;
